import React from 'react';
import { createContext, useState } from 'react';
import { getTwelveAMOfToday } from '../helpers/dates';

export const TransactionFilterContext = createContext();

export function TransactionFilterProvider({ children }) {
  const today = getTwelveAMOfToday();
  const weekAgo = new Date(today);
  weekAgo.setDate(today.getDate() - 7);

  const [transactionFilter, setTransactionFilter] = useState({
    selectedDates: [weekAgo, today],
    dropdownFilters: {},
    transactionSearch: {},
  });

  return (
    <TransactionFilterContext.Provider value={{ transactionFilter, setTransactionFilter }}>
      {children}
    </TransactionFilterContext.Provider>
  );
}
